import { Component, Vue } from 'types-vue'
import Agent from '../../_models/Agent'
import CCPService from '../../Services/CCP'

@Component
export default class AgentData extends Vue {
  
  protected agent: Agent | null = null
  protected setIntervalFun: any

  private updateAgent(agent: connect.Agent | null) {

    if(!agent) {
      this.agent = null
      return
    }

    const queues = agent
      .getRoutingProfile().queues
      .filter(queue => !!queue.name)
      .map(queue => queue.name)

    this.agent = {
      username: agent.getConfiguration().username,
      state: agent.getStatus().name,
      name: agent.getName(),
      queues: queues
    }
  }

  private onRefreshAgent(agent: connect.Agent) {
    this.updateAgent(agent)
  }

  protected async mounted() {
    this.setIntervalFun = setInterval(async () => {
      const agent = await CCPService.getAgent()
      if (!!agent) {
        agent.onRefresh(this.onRefreshAgent.bind(this))
        this.updateAgent(agent)
        clearInterval(this.setIntervalFun)
      }
    }, 500)
  }
}